import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  Paper,
  Icon,
  Divider,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Button from "components/CustomButtons/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    marginTop: "20px",
  },
}));

export default function MarkasReviewedModal({
  open,
  hasSpeakerNotes,
  speakerNotesError,
  onClose,
  voices,
  selectedVoice,
  setSelectedVoice,
  onConfirm,
  handleBooleanChange,
  assessment,
  chatbot,
  assessmentLevels,
  setAssessmentLevels,
  video,
}) {
  const classes = useStyles();
  const [explore, setExplore] = useState(assessment);
  const [experience, setExperience] = useState(assessment);
  const [excel, setExcel] = useState(assessment);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="voice-selection-modal"
      aria-describedby="voice-selection-description"
    >
      <Box
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "60%",
          backgroundColor: "white",
          boxShadow: 24,
          padding: "20px",
          borderRadius: "10px",
        }}
      >
        <Typography
          variant="h6"
          style={{ marginBottom: "20px", textTransform: "none" }}
        >
          Deliverable Requirements
        </Typography>
        <Divider style={{ marginBottom: "20px" }} />

        <Box
          mb={3}
          p={2}
          style={{ border: "2px solid #20677b", borderRadius: "8px" }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={video}
                  onChange={handleBooleanChange}
                  name="video"
                  color="primary"
                  style={{ padding: 0 }}
                />
              }
              label={
                <Typography
                  variant="body1"
                  style={{
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.87)",
                    marginLeft: "8px",
                  }}
                >
                  Convert slide deck to video
                </Typography>
              }
              style={{ alignItems: "flex-start", margin: 0 }}
            />
            <Tooltip
              title={
                <Box>
                  <Typography variant="body2" gutterBottom>
                    {speakerNotesError
                      ? speakerNotesError
                      : "Speaker notes from the slide deck will be used for narration."}
                  </Typography>
                </Box>
              }
              arrow
              placement="left"
            >
              <IconButton size="small">
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          {video && (
            <Box ml={4} mt={2}>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "12px",
                  fontWeight: 500,
                }}
              >
                Select a voice for narration:
              </Typography>
              <TableContainer
                component={Paper}
                elevation={0}
                style={{ border: "1px solid #e0e0e0" }}
              >
                <Table>
                  <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell
                        style={{
                          fontWeight: 600,
                          padding: "12px 16px",
                          width: "100px",
                        }}
                      >
                        Select
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: 600, padding: "12px 16px" }}
                      >
                        Voice Name
                      </TableCell>
                      <TableCell
                        style={{ fontWeight: 600, padding: "12px 16px" }}
                      >
                        Preview Audio
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {voices.map((voice, index) => (
                      <TableRow
                        key={index}
                        hover
                        style={{
                          backgroundColor:
                            selectedVoice === voice.name
                              ? "#f0f7ff"
                              : "transparent",
                        }}
                      >
                        <TableCell
                          style={{ padding: "12px 16px", textAlign: "center" }}
                        >
                          <Radio
                            checked={selectedVoice === voice.name}
                            onChange={(e) => setSelectedVoice(voice.name)}
                            value={voice.name}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell style={{ padding: "12px 16px" }}>
                          <Typography variant="body2">{voice.name}</Typography>
                        </TableCell>
                        <TableCell style={{ padding: "12px 16px" }}>
                          <audio
                            controls
                            type="audio/mpeg"
                            style={{ height: "32px", width: "250px" }}
                          >
                            <source src={voice.sampleUrl} />
                            Your browser does not support the audio element.
                          </audio>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </Box>

        <Box p={2} style={{ border: "2px solid #20677b", borderRadius: "8px" }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={assessment}
                  onChange={handleBooleanChange}
                  name="assessment"
                  color="primary"
                  style={{ padding: 0 }}
                />
              }
              label={
                <Typography
                  variant="body1"
                  style={{
                    fontWeight: 600,
                    color: "rgba(0, 0, 0, 0.87)",
                    marginLeft: "8px",
                  }}
                >
                  Include assessments for the course
                </Typography>
              }
              style={{ alignItems: "flex-start", margin: 0 }}
            />
            <Tooltip
              title={
                <Box>
                  <Typography variant="body2" gutterBottom>
                    Three levels of assessments will be included (Explore,
                    Experience, Excel).
                  </Typography>
                </Box>
              }
              arrow
              placement="left"
            >
              <IconButton size="small">
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Box style={{ textAlign: "right", marginTop: "20px" }}>
          <Button
            color="quCreateColor"
            variant="contained"
            onClick={onConfirm}
            disabled={video && !selectedVoice}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
